import { RiskAction as RiskActionEnum } from '@assess/shared/ontology-types';

import { ReasonCodeEntityClass, ReasonCodePrimaryType } from './reason-code-type.enums';
import { IReasonCodeGroupConfig, IReasonCodeType } from './reason-code-type.interfaces';

export class RiskActionType implements IReasonCodeType {
  readonly entityClass = ReasonCodeEntityClass.ProgramPeriodConfig;
  readonly primaryType = ReasonCodePrimaryType.FormRiskActionReason;

  constructor(readonly config: IReasonCodeGroupConfig) {}
}

export const FormRiskDenyReason = new RiskActionType({
  secondaryType: RiskActionEnum.Deny,
  statusLabel: '',
  isDefault: true,
});

export const FormRiskConfirmReason = new RiskActionType({
  secondaryType: RiskActionEnum.Confirm,
  statusLabel: '',
  isDefault: true,
});

export const FormRiskNoActionReason = new RiskActionType({
  secondaryType: RiskActionEnum.NoAction,
  statusLabel: '',
  isDefault: true,
});

export const FormRiskActionReason = [FormRiskDenyReason, FormRiskConfirmReason, FormRiskNoActionReason];
